import { IJob } from 'wisestep-api';

export const cacheJob = (job: IJob) => localStorage.setItem('selectedJob', JSON.stringify(job));

export const getCachedJob = () => {
  const getJob = localStorage.getItem('selectedJob');
  if (getJob) {
    return JSON.parse(getJob);
  }
  return null;
};

export const removeCachedJob = () => localStorage.removeItem('selectedJob');
